import { useNavigate } from 'react-router';
import { PostReviewRequest } from '../../generated/api/postReviewRequest';
import { closeDialog, setDialogSubmitFailed, setDialogSubmitting } from '../../public/site/dialogStore.js';
import { addNotification } from '../../public/site/notificationStore.js';
import { paths } from '../constants/pathVariables';
import { postReviewAsEmployer } from '../fetch';
import { t } from '../i18n';
import type { OnlineOrderReview } from '../../generated/api/onlineOrderReview';
import type { SubscriptionRedeemReview } from '../../generated/api/subscriptionRedeemReview';

export const useSubmitReview = (isEoe: boolean) => {
  const navigate = useNavigate();

  const submitReview = async (
    request: OnlineOrderReview | SubscriptionRedeemReview,
    reviewType: PostReviewRequest.ReviewTypeEnum,
    approve: boolean,
    mdmId?: string,
    rejectReason?: string
  ) => {
    try {
      const reviewRequest: PostReviewRequest = {
        onlineOrder: 'onlineOrderId' in request ? request : undefined,
        subscriptionRedeem: 'subscriptionId' in request ? request : undefined,
        reviewType,
        approve,
        rejectReason,
      };

      setDialogSubmitting(true);
      await postReviewAsEmployer(reviewRequest, isEoe, mdmId);
      closeDialog();

      const notificationMsg = approve
        ? t.XKKL('Order confirmation succeeded!')
        : t.YKJA('Rejection of device agreement succeeded.');
      addNotification(notificationMsg, 'success');

      if (isEoe && reviewType === PostReviewRequest.ReviewTypeEnum.SUBSCRIPTION_REDEEM) {
        navigate(paths.EMPLOYEE_CHANGE_REQUEST_ORDERS);
      } else if (isEoe) {
        navigate(paths.EMPLOYEE_ORDERS);
      } else if (reviewType === PostReviewRequest.ReviewTypeEnum.ONLINE_ORDER) {
        navigate(paths.CUSTOMER_ORDER_HOME);
      } else if (reviewType === PostReviewRequest.ReviewTypeEnum.SUBSCRIPTION_REDEEM) {
        navigate(paths.CUSTOMER_ORDER_REDEEM_REQUESTS);
      } else {
        navigate(paths.SELF_SERVICE_HOME);
      }
    } catch {
      setDialogSubmitFailed();
    }
  };

  return { submitReview };
};
